import { render, staticRenderFns } from "./ConflictfundMembershipFee.vue?vue&type=template&id=5225a954&scoped=true&"
import script from "./ConflictfundMembershipFee.vue?vue&type=script&lang=ts&"
export * from "./ConflictfundMembershipFee.vue?vue&type=script&lang=ts&"
import style0 from "./ConflictfundMembershipFee.vue?vue&type=style&index=0&id=5225a954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5225a954",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
